import {Pipe, PipeTransform} from '@angular/core';

/**
 * formatBytes(1024);       // 1 Ko
 * formatBytes('1024');     // 1 Ko
 * formatBytes(1234);       // 1.21 Ko
 * formatBytes(1234, 3);    // 1.205 Ko
 */
@Pipe({name: 'bytes'})
export class BytesPipe implements PipeTransform {

    constructor() {
    }

    transform(bytes: any, nbDecimals = 2): string {
        if (0 === bytes) {
            return '0';
        }
        const c = 1024, d = nbDecimals || 2, e = ['o', 'Ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'], f = Math.floor(Math.log(bytes) / Math.log(c));
        return parseFloat((bytes / Math.pow(c, f)).toFixed(d)) + ' ' + e[f];
    }
}
